import React from 'react';
import ReactDOM from 'react-dom';
import {zipObj} from 'ramda';

import modules from './modules';
import {FeatureFlagProvider} from './FeatureFlagContext';

export const renderReactView = ({
  el,
  ReactComponent,
  opts,
  module = ReactComponent,
}) => function ({
  options = {},
  appContext,
  debugModel,
} = {}) {
  const params = {
    // Components defined by other modules
    components: modules.getComponentsForModule(module),
    appContext,
    ...opts,
    ...options,
  };

  // Parameter mapping for path variables
  if (module.paramList) {
    Object.assign(params, zipObj(module.paramList, options.params || []));
  }

  const elements = React.createElement(FeatureFlagProvider, {debugModel: debugModel ? debugModel.toJSON() : {}}, [
    React.createElement(ReactComponent, {...params}, []),
  ]);

  ReactDOM.render(elements, el);
};

// If the upstream defines Backbone, we'll use it, otherwise we just build a render method
export const ReactView =
  (el, ReactComponent, opts = {}, {Backbone, userModel, appContext, module = ReactComponent} = {}) =>
    Backbone ?
      Backbone.View.extend(Object.assign({
        el,
        template: '',
        navId: 'reactView',
        sdaPageTitle: 'React Backbone View',
        hideHeader: true,
        initialize (options) {
          this.appContext = appContext;
          this.render(options); // Router expects the main view for a page to render itself.
          return this;
        },
        render (options) {
          renderReactView({el: this.el, ReactComponent, opts, module})({
            options,
            appContext: this.appContext,
            debugModel: userModel.debugModel || {},
          });
          return this;
        },

        destroy() {
          ReactDOM.unmountComponentAtNode(this.el);
        },
      }, opts)) :
      renderReactView({el: document.querySelector(el), ReactComponent, opts, module});

export default ReactView;
